var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1655 42H23.8451C22.8319 42 22 42.0856 22 42.1964V46.8025C22 46.911 22.8266 47 23.8451 47H66.1655C67.1788 47 68 46.9116 68 46.8025V42.1964C67.9947 42.0861 67.1788 42 66.1655 42Z",
    fill: "#407061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.503 0C19.9278 0 0 19.9206 0 44.5C0 69.0794 19.9278 89 44.503 89C69.081 89 89 69.0794 89 44.5C89 19.9206 69.081 0 44.503 0ZM44.503 81.5661C24.0301 81.5661 7.43148 64.9685 7.43148 44.5C7.43148 24.0226 24.0301 7.42802 44.503 7.42802C64.9788 7.42802 81.5685 24.0226 81.5685 44.5C81.5685 64.9685 64.9788 81.5661 44.503 81.5661Z",
    fill: "#407061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8921ea1dc858db587da751dc2246ba93.svg";
export { ForwardRef as ReactComponent };